module.exports = __webpack_public_path__ + "img/Interaction - exit.1339101b.jpg";